import React, { FC, useEffect, useState, useId } from 'react';
import cx from 'classnames';
import { Stack } from 'src/components-v2/Layout';
import Icon from 'threads5/Icon';

import styles from './TextArea.module.scss';

import { InputProps } from '../TextInput/TextInput';

const TextArea: FC<InputProps & { isLabelVisible?: boolean }> = ({
  className,
  isDarkMode,
  pattern,
  register = () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
  required,
  value = '',
  isLabelVisible,
  onChange = () => {}, // eslint-disable-line @typescript-eslint/no-empty-function
  ...restProps
}) => {
  const [inputValue, setInputValue] = useState(value);
  const generatedId = useId();

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  const id = restProps?.id ? `${restProps.id}-${generatedId}` : undefined;
  return (
    <div className={className}>
      <label
        htmlFor={id}
        className={cx(!isLabelVisible && styles.hiddenTextAreaLabel)}
      >
        {restProps?.label}
      </label>
      <textarea
        id={id}
        className={cx(
          styles.textArea,
          isDarkMode && styles.textAreaDark,
          restProps.errorMessage && styles.error,
        )}
        {...register(restProps.name, {
          ...(required && { required }),
          ...(pattern && { pattern }),
        })}
        onChange={(e) => {
          setInputValue(e.target.value);
          onChange(e);
        }}
        name={restProps?.name}
        placeholder={restProps?.placeholder}
        value={inputValue}
      />
      {restProps.errorMessage && (
        <Stack gap={1} direction='row' alignItems='center' sx={{ mb: 3 }}>
          <Icon name='AlertError' color='#f44e66' />
          <span>{required}</span>
        </Stack>
      )}
    </div>
  );
};

TextArea.displayName = 'TextInput';
export default TextArea;
